import axios from 'axios';
import { backendUrl } from '../constants/urls';
import clientApi from '../constants/urls';

const createAgent = (payload, token: string) => {
	return clientApi.post(`${backendUrl}/agents`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
};

const retrieveSingleAgent = (id) => {
	return clientApi.get(`${backendUrl}/admin/agents/${id}`);
};

const retrieveAgent = () => {
	return clientApi.get(`${backendUrl}/admin/agents`);
};

const retrieveAgetTranscations = (id, page = 1, limit = 10) => {
	return clientApi.get(`${backendUrl}/admin/agents/transactions/${id}?page=${page}&limit=${limit}`);
};

const updateAgent = (id, event) => {
	return clientApi.put(`${backendUrl}/agents/${id}`, event);
};

const retrieveAgentFloatRequests = (id) => {
	return clientApi.get(`${backendUrl}/admin/agents/floats/${id}`);
};

const topUpAgentAccount = (id, payload) => {
	return clientApi.put(`${backendUrl}/admin/agents/wallet/update/${id}`, payload);
};
const deactivate = (id: string) => {
	return clientApi.put(`${backendUrl}/admin/agents/disable/${id}`);
};

const activate = (id: string) => {
	return clientApi.put(`${backendUrl}/admin/agents/enable/${id}`);
};

const resetPin = (id: string) => {
	return clientApi.put(`${backendUrl}/admin/agents/reset-pin/default/${id}`);
};

const agentService = {
	createAgent,
	retrieveAgent,
	retrieveSingleAgent,
	retrieveAgetTranscations,
	retrieveAgentFloatRequests,
	topUpAgentAccount,
	updateAgent,
	deactivate,
	activate,
	resetPin,
};

export default agentService;
